/**
 * Created by baladewa on 10/27/16.
 * primary-key: is required if setting a selected row in the grid
 * selected-row-data: selected row object to select in the gird
 *
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('gridComponent', {
            templateUrl: function($attrs){
                return $attrs.template;
            },
            controller: function ($timeout, $window, $sce) {
                var vm = this;
                vm.selectedRow = null;
                vm.showResults = false;
                vm.dataRowList = [];
                vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
                vm.masterLists = {};
                vm.isAllSelected = false;

                vm.clickOnRow = function (event, index, rowContent, flag) {
                  console.log (event, index, rowContent, flag);
                    var passParams = {'selectedRowData':rowContent, flag:flag ,event:event};
                    vm.selectedRow = index;
                    vm.selectARow(passParams);
                    if(!angular.isUndefined(event)){
                    //event.stopPropagation();
                    }
                };

                vm.selectAll = function (){
                  for(var i = 0; i < vm.dataRowList.length; i++){
                    vm.dataRowList[i].isSelected = vm.isAllSelected;
                  }
                }

                vm.$onChanges = function (changeObj) {
                    if(changeObj.gridData && changeObj.gridData &&
                        (changeObj.gridData.currentValue !== changeObj.gridData.previousValue)){
                        vm.dataRowList=[];
                        $timeout(function () {
                            vm.dataRowList = changeObj.gridData.currentValue;
                            vm.selectedRow = null;
                            vm.showResults = true;
                        },10);
                    }
                    if(changeObj.masterDataLists && changeObj.masterDataLists &&
                            (changeObj.masterDataLists.currentValue !== changeObj.masterDataLists.previousValue)){
                            $timeout(function () {
                                vm.masterLists = changeObj.masterDataLists.currentValue;
                            },0)
                    }

                    if(changeObj.selectedRowData && changeObj.selectedRowData &&
                        (changeObj.selectedRowData.currentValue !== changeObj.selectedRowData.previousValue)){
                        if(!angular.isUndefined(vm.selectedRowData) && !angular.isUndefined(vm.primaryKey) && vm.selectedRowData!==null){
                            $timeout(function () {
                                var selectedIndex = _.findIndex(vm.dataRowList, function(item){
                                    return changeObj.selectedRowData.currentValue[vm.primaryKey] === item[vm.primaryKey];
                                });
                                if (!angular.isUndefined(selectedIndex)){
                                    vm.selectedRow = selectedIndex;
                                    var passParams = {'selectedRowData':vm.dataRowList[vm.selectedRow], flag:'row'};
                                    vm.selectARow(passParams);
                                }
                            },0);
                        }
                    }
                };

                angular.element($window).bind('resize', function(){
                    $timeout(function () {
                        vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
                    },0);
                });

               	vm.highlight = function(haystack, needle) {
                    if(!needle) {
                        return $sce.trustAsHtml(haystack);
                    }
                    return $sce.trustAsHtml(haystack.replace(new RegExp(needle, "gi"), function(match) {
                        return '<span class="highlightedText">' + match + '</span>';
                    }));
                };
            },
            bindings: {
                gridData: '<',
                rowInlineEditOptions: '<',
                selectARow: '&',
                masterDataLists: '<',
                selectedRowData: '<',
                primaryKey: '@'
            }
        });
})();
